<template>
  <div>
    <div v-if="displayWarningMsg" class="warning-message">
            <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
            {{ warningMessageText }}
    </div>
    <k-form :columns="10">
      <k-form-section :column-span="10">
        <k-form-field :label="textLabel" :required="true">
          <k-text-editor v-model="innerText" :read-only="readOnly" :maxLength="textMaxLength"/>
        </k-form-field>
      </k-form-section>
      <k-form-section :column-span="10">
        <k-form-field :label="fileLabel">
          <div class="k-dropfield small">
            <dropfield
              ref="dropfield"
              @file="onFile"
              :id="dropfieldId"
              :immediatePost="false"
              :enablePreviews="true"
              :disableDropfield="readOnly || disableDropfield"
              :accept="acceptedFormats"
            />
          </div>
        </k-form-field>
      </k-form-section>
      <div class="feedback-save">
        <button
          type="button"
          class="btn btn-primary"
          :disabled="isSaveDisabled"
          @click="emitSave"
        >
          {{ saveButtonText }}
        </button>
      </div>
    </k-form>
  </div>
</template>
<style scoped>
.warning-message {
  background: var(--kate-warning);
  color: var(--kate-type-dark);
  padding: 8px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.feedback-save {
  display: flex;
  grid-column: 10;
  justify-content: flex-end;
}

.k-dropfield.small :deep(.k-dropbox) {
  min-height: 100px;
}
</style>
<script>
import { KForm, KFormSection, KFormField } from '@base-components/forms/index';
import KTextEditor from '@base-components/k-text-editor.vue';
import Dropfield from '@base-components/dropfield.vue';

export default {
  name: 'KTextEditorWithFileUpload',
  components: {
    KForm,
    KFormSection,
    KFormField,
    KTextEditor,
    Dropfield,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    displayWarningMsg: {
      type: Boolean,
      default: false,
    },
    warningMessageText: {
      type: String,
      default: 'Warning: Saving will overwrite existing feedback for the current version.',
    },
    acceptedFormats: {
      type: String,
      default: '',
    },
    dropfieldId: {
      type: String,
      default: 'item-upload',
    },
    disableDropfield: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: 'General feedback',
    },
    fileLabel: {
      type: String,
      default: 'File upload (optional)',
    },
    saveButtonText: {
      type: String,
      default: 'Save',
    },
    requireText: {
      type: Boolean,
      default: false,
    },
    textMaxLength: {
      type: Number,
      default: 1024,
    },
  },
  emits: ['update:modelValue', 'save', 'file-selected'],
  data() {
    return {
      file: null,
    };
  },
  computed: {
    innerText: {
      get() { return this.modelValue; },
      set(v) { this.$emit('update:modelValue', v); },
    },
    isSaveDisabled() {
      const emptyText = !String(this.innerText || '').trim();
      const textBlocked = this.requireText ? emptyText : false;
      return this.readOnly || textBlocked;
    },
  },

  methods: {
    onFile(file) {
      this.file = file || null;
      this.$emit('file-selected', this.file);
    },
    emitSave() {
      this.$emit('save');
    },
    reset() {
      this.file = null;
      this.$emit('update:modelValue', '');
      if (this.$refs.dropfield) {
        this.$refs.dropfield.reset();
      }
    },
  },
};
</script>
